/**
 * Клиент серверного рейтинга. Очки — всего заработано монет на рынке (stats.coinsEarned).
 * У каждого острова своя запись: идентификатор = «<id браузера>:<зерно мира>». Секрет, выданный сервером
 * при первой отправке, хранится в localStorage и защищает запись от чужих обновлений.
 */
import type { GameState } from '../core/types';
import { playerId } from './client';

const SECRETS_KEY = 'paradise-isle:lbSecrets';

export interface LbRow { rank: number; name: string; score: number; level: number; me: boolean }
export interface LbView { top: LbRow[]; me: LbRow | null; total: number }

export const lbId = (state: GameState): string => `${playerId()}:${state.seed >>> 0}`;

function secrets(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem(SECRETS_KEY) ?? '{}') as Record<string, string>; } catch { return {}; }
}
function saveSecret(id: string, secret: string): void {
  try { localStorage.setItem(SECRETS_KEY, JSON.stringify({ ...secrets(), [id]: secret })); } catch { /* ignore */ }
}

let lastSent = '';

/** Отправить текущие очки. Возвращает true, если сервер принял. Повторные одинаковые отправки пропускаются. */
export async function submitScore(state: GameState, force = false): Promise<boolean> {
  const id = lbId(state);
  const score = Math.round(state.stats.coinsEarned || 0);
  const sig = `${id}|${score}|${state.player.name}|${state.player.level}`;
  if (!force && sig === lastSent) return true;
  try {
    const r = await fetch('/api/lb/submit', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, secret: secrets()[id], name: state.player.name, score, level: state.player.level }),
    });
    if (!r.ok) return false;
    const j = (await r.json()) as { secret?: string };
    if (j.secret) saveSecret(id, j.secret);
    lastSent = sig;
    return true;
  } catch { return false; }
}

export async function fetchLeaderboard(state: GameState): Promise<LbView | null> {
  try {
    const r = await fetch(`/api/lb?id=${encodeURIComponent(lbId(state))}`);
    return r.ok ? ((await r.json()) as LbView) : null;
  } catch { return null; }
}
